var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"c-current-glyph-effects__header",style:(_vm.textStyle)},[_vm._v(" "+_vm._s(_vm.setName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }